import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  Renderer2,
  SimpleChanges,
} from "@angular/core";

@Component({
  selector: "n-element",
  template: ` <div class="n-element"></div>`,
})
export class ElementComponent implements OnInit {
  _content: Record<string, any> = {};

  @Input("m")
  margin: number;

  @Input("ml")
  marginLeft: number;

  @Input("mr")
  marginRight: number;

  @Input("mt")
  marginTop: number;

  @Input("mb")
  marginBottom: number;

  @Input("p")
  padding: number;

  @Input("pl")
  paddingLeft: number;

  @Input("pr")
  paddingRight: number;

  @Input("pt")
  paddingTop: number;

  @Input("pb")
  paddingBottom: number;

  @Input("w")
  width: string;

  @Input("h")
  height: string;

  @Input("colspan")
  colspan: number;

  @Input("rowspan")
  rowspan: number;

  @Input("bg-color")
  bgColor: string;

  _attributes: Record<string, any> = {};

  constructor(private renderer: Renderer2, protected el: ElementRef) {}

  addClassToRootElement(className: string) {
    const rootElement = this.el.nativeElement;
    this.renderer.addClass(rootElement, className);
  }

  addStyleToRootElement(style: string, value: string) {
    const rootElement = this.el.nativeElement;
    console.log("set style", style, value, rootElement.children[0]);
    this.renderer.setStyle(rootElement, style, value);
  }

  ngOnInit() {
    this.refreshDisplay();
  }
  removeAllClasses() {
    const hostElement = this.el.nativeElement;
    const classList = hostElement.classList;
    while (classList.length > 0) {
      this.renderer.removeClass(hostElement, classList.item(0));
    }
  }
  refreshDisplay() {
    this.removeAllClasses();
    this.addClassToRootElement(`block`);
    if (this.margin) {
      this.addClassToRootElement(`m-${this.margin}`);
    }
    if (this.marginLeft) {
      this.addClassToRootElement(`ml-${this.marginLeft}`);
    }
    if (this.marginRight) {
      this.addClassToRootElement(`mr-${this.marginRight}`);
    }
    if (this.marginTop) {
      this.addClassToRootElement(`mt-${this.marginTop}`);
    }
    if (this.marginBottom) {
      this.addClassToRootElement(`mb-${this.marginBottom}`);
    }
    if (this.padding) {
      this.addClassToRootElement(`p-${this.padding}`);
    }
    if (this.paddingLeft) {
      this.addClassToRootElement(`pl-${this.paddingLeft}`);
    }
    if (this.paddingRight) {
      this.addClassToRootElement(`pr-${this.paddingRight}`);
    }
    if (this.paddingTop) {
      this.addClassToRootElement(`pt-${this.paddingTop}`);
    }
    if (this.paddingBottom) {
      this.addClassToRootElement(`pb-${this.paddingBottom}`);
    }
    if (this.width) {
      if (this.width === "grow") {
        this.addClassToRootElement(`flex-grow`);
      } else {
        this.addClassToRootElement(`w-${this.width}`);
      }
    }
    if (this.height) {
      if (this.height === "grow") {
        this.addClassToRootElement(`flex-grow`);
      } else {
        this.addClassToRootElement(`h-${this.height}`);
      }
    }
    if (this.colspan) {
      this.addClassToRootElement(`col-span-${this.colspan}`);
    }
    if (this.rowspan) {
      this.addClassToRootElement(`row-span-${this.rowspan}`);
    }
    if (this.bgColor) {
      console.log("set bg color", this.bgColor);
      this.addStyleToRootElement("background-color", this.bgColor);
    }
  }

  @Input()
  set content(content: Record<string, any>) {
    this._content = content;
    this.refreshDisplay();
  }

  get content(): Record<string, any> {
    return this._content;
  }
}
